<style lang="scss" scoped>
.tip-card {
    .tip-card-body {
        .tip-card-images {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -4px;
            .item {
                height: 66px;
                width: 66px;
                flex: 0 0 calc((100% - 82px) / 2);
                margin-right: 8px;
                img {
                    object-fit: cover;
                }
            }
            .more {
                border-radius: 2px;
                background-color: var(--gray-light);
                width: 66px;
                flex: auto;
                line-height: 66px;
                margin-right: 0px;
            }
        }
    }
}
</style>

<template>
    <div v-if="currentUser.permissions.includes('tip.read')">
        <div class="px-0 px-md-44 pt-16 pt-md-32">

            <!-- Header -->
            <div class="row mb-32">
                <div class="col-12 col-md-4 col-lg-3 mb-16 mb-mb-0">
                    <el-input v-model="search" type="text" class="small mb-0" :name="$t('form-elements.search')" :hasLabel="false" :placeholder="$t('form-elements.search_placeholder')"></el-input>
                </div>
                <div class="col-12 col-md-4 col-lg-3 ml-auto">
                    <el-select class="small" v-model="lang" :options="languages" :hasLabel="false" :placeholder="$t('form-elements.language_placeholder')"></el-select>
                </div>
            </div>

            <div class="d-flex mb-32">
                <div class="px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer d-flex flex-row" @click="current_profession_type_id = 1" :class="{ 'bg-border-color opacity-100' : current_profession_type_id === 1 }">
                    <i-sun class="i-14 mr-8 d-none d-md-block my-auto"></i-sun>
                    {{ $t('pages.advice.dayservice') }}
                </div>
                <div class="px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer d-flex flex-row" @click="current_profession_type_id = 2" :class="{ 'bg-border-color opacity-100' : current_profession_type_id === 2 }">
                    <i-repeat class="i-14 mr-8 d-none d-md-block my-auto"></i-repeat>
                    {{ $t('pages.advice.shifts') }}
                </div>
                <div class="px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer d-flex flex-row" @click="current_profession_type_id = 3" :class="{ 'bg-border-color opacity-100' : current_profession_type_id === 3 }">
                    <i-user class="i-14 mr-8 d-none d-md-block my-auto"></i-user>
                    {{ $t('pages.advice.non_working') }}
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-4 col-xl-3" v-for="(tip, tip_index) in filteredTips" :key="tip_index">
                    <card-tip :data="tip" :editable="true" link="admin-tips-show" goToLink="id" :showTags="true"></card-tip>
                </div>
            </div>

        </div>
    </div>
    <div v-else class="container" style="height: calc(100% - 68px)">
        <div class="row h-100">
            <div class="col-auto m-auto">
                <image-no-access height="300"></image-no-access>
                <h4 class="text-primary-dark fw-b text-center mt-32">{{ $t('errors.no_admin_access') }}</h4>
                <p class="text-center">{{ $t('errors.no_admin_access_desc') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ElInput, ElSelect } from '@/components/forms'
import { CardTip } from '@/components/cards'

import hasLanguages from '@/components/forms/has-languages';

export default {

    mixins: [hasLanguages],

    components: { ElInput, ElSelect, CardTip },

    data() {
        return {
            current_profession_type_id: 1,
            search: '',
        }
    },

    mounted() {
        if (this.$route.query.type)
            this.current_profession_type_id = this.$route.query.type

        this.$store.dispatch('tips/readTips')
    },

    computed: {
        filteredTips() {
            if (!this.$store.getters['tips/all'].length > 0) return []

            return this._.orderBy(this.$store.getters['tips/all'].filter(tip => {
                return (tip.language === this.lang.value && parseInt(tip.profession_type_id) === parseInt(this.current_profession_type_id) &&
                    (tip.title.toLowerCase().includes(this.search.toLowerCase()) || tip.tip_categories.filter(tag => tag.toLowerCase().includes(this.search.toLowerCase())).length > 0))
            }), 'day')
        },
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
